require('./brokerStocksBuyStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const classNames = require('classnames');
// @ commons
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const { OKMessage } = require('commonsComponents/OKMessage');
// @ utils
const { formatAmount } = require('utilities/currencyHelper');

// @ constants
const {
    BROKER_STOCKS_BUY_STEP1_MAX_TITLE_DIGITS,
    BROKER_STOCKS_BUY_STEP1_SELECTED_OPTION,
    BROKER_STOCKS_BUY_STEP1_BUY_FOR,
    BROKER_STOCKS_BUY_STEP1_ORDER_TYPE,
    BROKER_STOCKS_BUY_STEP1_ORDER_TYPE_LIMITED,
    BROKER_STOCKS_BUY_STEP1_VALIDITY_DATE,
    BROKER_STOCKS_BUY_STEP1_BUY_FOR_INPUT,
    BROKER_STOCKS_BUY_STEP1_BUY_FOR_CONDITIONAL_INPUT,
    BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER,
    SPANISH_CONTINUES_MARKET_ISO_CODE,
    SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK,
    MAX_FRACTION_LENGTH_IN_STORE_LIMITED,
    MAX_FRACTION_LENGTH_IN_STORE,
    FIRST_STEP
} = require('constants/index');
const language = getLanguage();
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @ components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { AmountInput } = require('commonsComponents/amountInput');
const { InputSafe } = require('commonsComponents/inputSafe');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const StocksContractDropdown = require('components/broker/commons/stocksContractDropdown/stocksContractDropdown');
const { LoadingSection } = require('commonsComponents/loadingSection');
const BrokerHolidayErrorModal = require('components/broker/commons/brokerHolidayErrorModal/brokerHolidayErrorModal');
class BrokerStocksBuyStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.updateForm = this.updateForm.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleBuyForRadiosChange = this.handleBuyForRadiosChange.bind(this);
        this.handleOrderTypeRadiosChange = this.handleOrderTypeRadiosChange.bind(this);
        this.onHandleDateChange = this.onHandleDateChange.bind(this);
        this.handleBuyForInputChange = this.handleBuyForInputChange.bind(this);
        this.conditionalInput = this.conditionalInput.bind(this);
        this.handleBuyForConditionalInputChange = this.handleBuyForConditionalInputChange.bind(
            this
        );
        this.handleOrderTypeLimitedChange = this.handleOrderTypeLimitedChange.bind(this);
        this.buildForTheBestRadioButton = this.buildForTheBestRadioButton.bind(this);
        this.validateProductPrice = this.validateProductPrice.bind(this);
        this.handleHolidayModalErrorOpen = this.handleHolidayModalErrorOpen.bind(this);
    }

    componentDidMount() {
        const { productPrice, step1 } = this.props;
        const orderTypeLimited = step1.get(BROKER_STOCKS_BUY_STEP1_ORDER_TYPE_LIMITED);
        const roundedPrice = parseInt(productPrice) + 1;

        const buyFor = step1.get(BROKER_STOCKS_BUY_STEP1_BUY_FOR);

        if (buyFor !== 'titleAmount') {
            this.updateForm(0, BROKER_STOCKS_BUY_STEP1_BUY_FOR_INPUT);
        }

        if (!orderTypeLimited) {
            this.handleOrderTypeLimitedChange(0);
        }

        if (!step1.get('valid')) {
            this.updateForm('', BROKER_STOCKS_BUY_STEP1_BUY_FOR_CONDITIONAL_INPUT, roundedPrice);
            this.updateForm('', BROKER_STOCKS_BUY_STEP1_ORDER_TYPE_LIMITED, roundedPrice);
        }
    }

    componentDidUpdate(prevProps) {
        // updates input price of approx import to be higher than product Buy Price
        const { step1, productPrice } = this.props;

        if (prevProps.productPrice !== productPrice) {
            const buyForDefaultPrice = step1.get('buyForConditionalInput');
            const initialPrice = this.validateProductPrice(buyForDefaultPrice, productPrice);
            this.updateForm(
                parseInt(initialPrice),
                BROKER_STOCKS_BUY_STEP1_BUY_FOR_INPUT,
                parseInt(initialPrice)
            );
        }
    }

    onHandleDateChange(date) {
        this.updateForm(date, BROKER_STOCKS_BUY_STEP1_VALIDITY_DATE);
    }

    buildForTheBestRadioButton() {
        const { productIso } = this.props;
        const forTheBestLabel = formatText('broker-stocksBuyStep1ForTheBestLabel');

        // Get the two first letter from ISIN to know if it is a spanish market
        if (
            productIso === SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK ||
            productIso === SPANISH_CONTINUES_MARKET_ISO_CODE
        ) {
            return (
                <RadioButton
                    key="forTheBestRadioButton"
                    label={forTheBestLabel}
                    value="forTheBest"
                    className="stocks-buy-step1__radio-button"
                />
            );
        }
    }

    buildRadioButtons() {
        const { productCurrency } = this.props;
        const toMarketLabel = formatText('broker-stocksBuyStep1ToMarketLabel');
        const limitedLabel = `${formatText(
            'broker-stocksBuyStep1LimitedLabel'
        )} (${productCurrency})`;
        const forTheBestRadioButton = this.buildForTheBestRadioButton();

        const marketRadioButton = (
            <RadioButton
                key="toMarketRadioButton"
                label={toMarketLabel}
                value="toMarket"
                className="stocks-buy-step1__radio-button"
            />
        );

        const limitedRadioButton = (
            <RadioButton
                key="limitedRadioButton"
                label={limitedLabel}
                value="limited"
                className="stocks-buy-step1__radio-button"
            />
        );

        const radioButtons = [marketRadioButton, forTheBestRadioButton, limitedRadioButton];

        return radioButtons.filter(value => value !== undefined);
    }

    conditionalInput(value, errorState, errorMessage, callback, modifier, inputfoot) {
        const inputFootValidator = errorState ? undefined : inputfoot;
        const classWithModifier = `stocks-buy-step1__text-input-wrapper--${modifier}`;
        const customClass = classNames('stocks-buy-step1__text-input-wrapper', {
            [classWithModifier]: modifier
        });
        if (modifier !== 'titles') {
            const maxDecimals =
                modifier.includes('limited')
                    ? MAX_FRACTION_LENGTH_IN_STORE_LIMITED
                    : MAX_FRACTION_LENGTH_IN_STORE;

            return (
                <div className={customClass}>
                    <AmountInput
                        amount={value}
                        callback={callback}
                        error={errorState}
                        errorMsg={errorMessage}
                        maxBackEndFractionLength={maxDecimals}
                        language={language}
                        hideFocusZero
                    />
                    {inputFootValidator}
                </div>
            );
        } else {
            return (
                <div className={customClass}>
                    <InputSafe
                        type="text"
                        value={value}
                        autoComplete="off"
                        onChange={callback}
                        errorState={errorState}
                        errorMessage={errorMessage}
                    />
                    {inputFootValidator}
                </div>
            );
        }
    }

    handleBuyForConditionalInputChange(price) {
        const { productPrice, productFile } = this.props;
        const catalogData = productFile.get('catalogData');

        if (catalogData.get('operatedByLot')){
            this.props.resetLotValuesByLot();
        }
        const titlesAmount = Math.floor(price / productPrice);
        this.updateForm(
            parseFloat(price),
            BROKER_STOCKS_BUY_STEP1_BUY_FOR_CONDITIONAL_INPUT,
            productPrice,
            catalogData
        );
        if (!isNaN(titlesAmount)) {
            this.updateForm(titlesAmount, BROKER_STOCKS_BUY_STEP1_BUY_FOR_INPUT);
        }
    }

    handleBuyForInputChange(event) {
        const { value } = event.target;
        const { productFile } = this.props;
        const catalogData = productFile.get('catalogData');
        if (catalogData.get('operatedByLot')){
            this.props.resetLotValuesByLot();
        }
        const parsedValue = isNaN(parseFloat(value)) ? '' : parseFloat(value);

        if (value.length < BROKER_STOCKS_BUY_STEP1_MAX_TITLE_DIGITS) {
            this.updateForm(
                parsedValue,
                BROKER_STOCKS_BUY_STEP1_BUY_FOR_INPUT,
                this.validateProductPrice(this.props.productPrice, this.props.productPrice),
                catalogData
            );
        }
    }

    handleBuyForRadiosChange(value) {
        const { step1 } = this.props;
        const isValidating = step1.get('isValidating');

        this.updateForm(value, BROKER_STOCKS_BUY_STEP1_BUY_FOR);
        if(!isValidating){
            this.updateForm(value, BROKER_STOCKS_BUY_STEP1_BUY_FOR);
        }
    }

    handleHolidayModalErrorOpen() {
        this.props.setHolidayError();
    }

    handleOrderTypeLimitedChange(price) {
        this.updateForm(parseFloat(price), BROKER_STOCKS_BUY_STEP1_ORDER_TYPE_LIMITED);
    }

    handleOrderTypeRadiosChange(value) {
        const { step1 } = this.props;
        const isValidating = step1.get('isValidating');
        if (value !== 'limited') {
            //this.props.resetStep1LimitedInput();
        }
        if(!isValidating){
            this.updateForm(value, BROKER_STOCKS_BUY_STEP1_ORDER_TYPE);
        }
    }

    buildStocksContractDropdownOptions() {
        const { immStocksContracts } = this.props;

        const processedStocksContract = immStocksContracts.map((entry, index) => {
            const associatedAccountBalance = {
                amount: entry.getIn(['associatedAccountBalance', 'amount']),
                currency: entry.getIn(['associatedAccountBalance', 'currency'])
            };

            return entry.merge({
                value: index,
                walletBalance: associatedAccountBalance
            });
        });

        return processedStocksContract.toJS();
    }

    handleSelectChange(value) {
        this.updateForm(value, BROKER_STOCKS_BUY_STEP1_SELECTED_OPTION);
    }

    updateForm(value, field, productPrice, catalogData = false) {
        this.props.updateStep1Form({ value, field }, productPrice, catalogData);
    }

    validateProductPrice(inputPrice, productPrice) {
        //const roundedPrice = parseInt(productPrice.toFixed(0), 10);

        if (parseFloat(inputPrice) < parseFloat(productPrice)) {
            // is one more than the floor of the price of the product
            return parseFloat(productPrice);
        } else {
            return parseFloat(inputPrice);
        }
    }

    buildLegalSection() {
        return (
            <ContactCenterRender>
                <section className="stocks-buy-step1__group-div">
                    <BlockInfo>{ formatText('broker-stocksBuyStep1LegalText') }</BlockInfo>
                </section>
            </ContactCenterRender>
        );
    }

    render() {
        const { productIso, productFile, immStocksBuy, immStocksContracts, immAccounts } = this.props;
        const formState = this.props.step1;
        const formErrors = this.props.errors;
        const buyForInputError = formErrors.get('buyForInput');
        const buyForConditionalInputError = formErrors.get('buyForConditionalInput');
        const buyForConditionalInputLowerThanLimitedImportError = formErrors.get(
            'buyForConditionalInputLowerThanLimitedImportError'
        );
        const limitedInputError = formErrors.get('orderTypeLimited');
        const stocksContractError = formErrors.get('stocksContractSelectedValue');
        const buyForInputErrorMessage = formatText('broker-stocksBuyStep1NoTitlesOrderError');
        const buyForConditionalInputErrorMessage = formatText(
            'broker-stocksBuyStep1NoAproxAmountOrderError'
        );
        const buyForConditionalInputLowerThanLimitedImportErrorMessage = formatText(
            'broker-stocksBuyStep1LowerThanLimitedImportError'
        );
        const limitedInputErrorMessage = formatText('broker-stocksBuyStep1NoLimitedAmmount');
        const orderType = formState.get(BROKER_STOCKS_BUY_STEP1_ORDER_TYPE);
        const orderTypeLimited = formState.get(BROKER_STOCKS_BUY_STEP1_ORDER_TYPE_LIMITED);
        const buyFor = formState.get(BROKER_STOCKS_BUY_STEP1_BUY_FOR);
        const buyForInput = formState.get(BROKER_STOCKS_BUY_STEP1_BUY_FOR_INPUT);
        const buyForConditionalInput = formState.get(
            BROKER_STOCKS_BUY_STEP1_BUY_FOR_CONDITIONAL_INPUT
        );
        const firstDate = formState.get('firstDate');
        const validityDate = formState.get('validityDate');
        const limitDate = formState.get('limitDate');
        const selectedOptionIndex = formState.get(BROKER_STOCKS_BUY_STEP1_SELECTED_OPTION);

        const selectPlaceholderText = formatText('broker-stocksBuyStep1SelectPlaceholder');
        const titleAmountLabel = formatText('broker-stocksBuyStep1TitleAmountLabel');
        const approxImportEurLabel = `${formatText('broker-stocksBuyStep1ApproxImportEurLabel')}`;
        const radioButtons = this.buildRadioButtons();

        const selectOptions = this.buildStocksContractDropdownOptions();
        const excludeDates = formState.get('excludeDates');
        const catalogData = productFile.get('catalogData');
        const crfRequired = productFile.get('crfRequired');
        const w8Required = productFile.get('w8Required');
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');

        let titlesAmountInput;
        let approxImportInput;
        let limitedInput;
        let dropdownSection;
        let tooltipLot = null;
        let operatedByLotLabel;
        let errorMessage;

        if (this.props.immMyInvestments.get('isFetching')) {
            dropdownSection = <LoadingSection />;
        } else {
            dropdownSection = (
                <StocksContractDropdown
                    onStockContractChange={this.handleSelectChange}
                    immAccounts={immAccounts}
                    immBrokerStocksContract={immStocksContracts}
                    options={selectOptions}
                    selectedValue={selectedOptionIndex}
                    placeholder={selectPlaceholderText}
                    modifier={BROKER_STOCKS_CONTRACT_DROPDOWN_ACCOUNT_MODIFIER}
                    errorState={stocksContractError}
                    errorMessage={formatText('broker-stocksBuyStep1NoAccountError')}
                    loading={isBlockedAccountsLoading}
                />
            );
        }


        if (catalogData.get('operatedByLot')) {
            const lot = formatAmount(catalogData.get('lot'), undefined, 0);
            const lotValue = formatAmount(catalogData.get('lotValue'), undefined, 2);

            tooltipLot = (
                <OKTooltip
                    content="brokerOperacionPorLotes-brokerOperacionPorLotes_operatedByLots"
                    offset={[0, -5]}
                />
            );
            if (buyFor === 'titleAmount') {
                const valueLabel = formatAmount(immStocksBuy.getIn(['steps', FIRST_STEP, 'buyForInput_importToBuy']));

                let titleQuantityNotMultiplo = immStocksBuy.getIn(['steps', FIRST_STEP, 'errors','notMultiploLote']);
                let titleQuantityMinorThanLote = immStocksBuy.getIn(['steps', FIRST_STEP, 'errors','minorThanLote']);

                operatedByLotLabel = <FormattedText className="stocks-buy-step1__input-foot" value="brokerOperacionPorLotes-brokerOperacionPorLotes_buyByTitle" injectedStrings={[lot, valueLabel]}/>;

                if (titleQuantityNotMultiplo && !titleQuantityMinorThanLote) {
                    errorMessage = formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_notMultiplo');
                }
                if (titleQuantityMinorThanLote) {
                    errorMessage = <FormattedText value="brokerOperacionPorLotes-brokerOperacionPorLotes_notEnoughTitlesForLotError" injectedStrings={[lot]}/>;
                }

                titlesAmountInput = this.conditionalInput(
                    buyForInput,
                    (titleQuantityNotMultiplo || titleQuantityMinorThanLote),
                    errorMessage,
                    this.handleBuyForInputChange,
                    'titles',
                    operatedByLotLabel
                );
            }
            if (buyFor === 'aproxImport') {
                const valueLabel = formatAmount(immStocksBuy.getIn(['steps', FIRST_STEP, 'buyForConditionalInput_titlesToBuy']));
                let conditionalIsNotMultipleError = immStocksBuy.getIn(['steps', FIRST_STEP, 'errors', 'conditionalIsNotMultipleError'], false);
                let conditionalInputLowerThanLotValueError = immStocksBuy.getIn(['steps', FIRST_STEP, 'errors', 'conditionalInputLowerThanLotValueError'], false);

                operatedByLotLabel = <FormattedText className="stocks-buy-step1__input-foot" value="brokerOperacionPorLotes-brokerOperacionPorLotes_buyByImport" injectedStrings={[lotValue, lot, valueLabel]}/>;

                if (conditionalIsNotMultipleError && !conditionalInputLowerThanLotValueError) {
                    errorMessage = formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_importeNotMultiplo');
                }
                if (conditionalInputLowerThanLotValueError) {
                    errorMessage = <FormattedText value="brokerOperacionPorLotes-brokerOperacionPorLotes_minimumImport" injectedStrings={[lotValue]}/>;
                }

                approxImportInput = this.conditionalInput(
                    buyForConditionalInput,
                    (conditionalIsNotMultipleError || conditionalInputLowerThanLotValueError),
                    errorMessage,
                    this.handleBuyForConditionalInputChange,
                    'approx',
                    operatedByLotLabel
                );
            }
        }
        else {
            if (buyFor === 'titleAmount'){
                titlesAmountInput = this.conditionalInput(
                    buyForInput,
                    buyForInputError,
                    buyForInputErrorMessage,
                    this.handleBuyForInputChange,
                    'titles'
                );
            }

            if (buyFor === 'aproxImport') {
                const conditionalInputErrorState = buyForConditionalInputError ? buyForConditionalInputError : buyForConditionalInputLowerThanLimitedImportError;
                const conditionalInputErrorMessage = buyForConditionalInputError ? buyForConditionalInputErrorMessage : buyForConditionalInputLowerThanLimitedImportErrorMessage;

                approxImportInput = this.conditionalInput(
                    buyForConditionalInput,
                    conditionalInputErrorState,
                    conditionalInputErrorMessage,
                    this.handleBuyForConditionalInputChange,
                    'approx'
                );
            }
        }

        if (orderType === 'limited') {
            const limitedLabel = catalogData.get('operatedByLot') ?
            (
                <div className="stocks-buy-step1__input-foot">
                    {formatText('brokerOperacionPorLotes-brokerOperacionPorLotes_titleLimitPrice')}
                </div>
            ) : null;
            if (
                productIso === SPANISH_CONTINUES_MARKET_ISO_CODE_ONLY_STOCK ||
                productIso === SPANISH_CONTINUES_MARKET_ISO_CODE
            ) {
                limitedInput = this.conditionalInput(
                    orderTypeLimited,
                    limitedInputError,
                    limitedInputErrorMessage,
                    this.handleOrderTypeLimitedChange,
                    'limited-spanish-market',
                    limitedLabel
                );
            } else {
                limitedInput = this.conditionalInput(
                    orderTypeLimited,
                    limitedInputError,
                    limitedInputErrorMessage,
                    this.handleOrderTypeLimitedChange,
                    'limited',
                    limitedLabel
                );
            }
        }
        const radioButtonGroup = catalogData.get('operatedByLot') ?
        (<div>
            <RadioButtonGroup
                selectedValue={buyFor}
                onChange={this.handleBuyForRadiosChange}
                name="buyForRadioGroup"
                idPrefix="buyForRadioGroup"
            >
                <RadioButton
                    label={titleAmountLabel}
                    value="titleAmount"
                    className="stocks-buy-step1__radio-button stocks-buy-step1__radio-button-title"
                />
                {tooltipLot}
                <RadioButton
                    label={approxImportEurLabel}
                    value="aproxImport"
                    className="stocks-buy-step1__radio-button stocks-buy-step1__radio-button-import"
                />
            </RadioButtonGroup>
        </div>
        ):
        (
            <div>
                <RadioButtonGroup
                    selectedValue={buyFor}
                    onChange={this.handleBuyForRadiosChange}
                    name="buyForRadioGroup"
                    idPrefix="buyForRadioGroup"
                >
                    <RadioButton
                        label={titleAmountLabel}
                        value="titleAmount"
                        className="stocks-buy-step1__radio-button stocks-buy-step1__radio-button-title"
                    />
                    <RadioButton
                        label={approxImportEurLabel}
                        value="aproxImport"
                        className="stocks-buy-step1__radio-button stocks-buy-step1__radio-button-import"
                    />
                </RadioButtonGroup>
            </div>
        );
        const legalSection = this.buildLegalSection();

        return (
            <div className="stocks-buy-step1">
                {legalSection}
                <header className="stocks-buy-step1__header">
                    <h2 className="stocks-buy-step1__header-title">
                        <FormattedText value="broker-stocksBuyStep1HeaderTitle" />
                    </h2>
                </header>
                <div className="stocks-buy-step1__group-div stocks-buy-step1__dropdown">
                    {dropdownSection}
                </div>
                <div className="stocks-buy-step1__group-div">
                    <h2 className="stocks-buy-step1__subtitle">
                        <FormattedText value="broker-stocksBuyStep1BuyForText" />
                        <OKTooltip
                            content="broker-stocksBuyStep1BuyForTextTooltip"
                            offset={[0, -15]}
                        />
                    </h2>
                    {radioButtonGroup}

                    {titlesAmountInput}

                    {approxImportInput}
                </div>
                <div className="stocks-buy-step1__group-div">
                    <h2 className="stocks-buy-step1__subtitle stocks-buy-step1__subtitle--order-type">
                        <FormattedText value="broker-stocksBuyStep1OrderTypeTitle" />
                        <OKTooltip
                            content="broker-stocksBuyStep1OrderTypeTitleTooltip"
                            offset={[0, -15]}
                        />
                    </h2>
                    <RadioButtonGroup
                        selectedValue={orderType}
                        name="orderTypeRadioGroup"
                        idPrefix="orderTypeRadioGroup"
                        onChange={this.handleOrderTypeRadiosChange}
                    >
                        {radioButtons}
                    </RadioButtonGroup>

                    {limitedInput}
                </div>
                <div className="stocks-buy-step1__group-div">
                    <div className="stocks-buy-step1__datepicker-label">
                        <h2 className="stocks-buy-step1__subtitle stocks-buy-step1__datepicker-subtitle">
                            <FormattedText value="broker-stocksBuyStep1ValidityDateLabel" />
                            <OKTooltip
                                content="broker-stocksBuyStep1ValidityDateLabelTooltip"
                                offset={[0, -15]}
                            />
                        </h2>
                    </div>
                    <div className="stocks-buy-step1__group-div-datepicker">
                        <DatePickerCustom
                            callback={this.onHandleDateChange}
                            selectedDate={validityDate}
                            newSelectedDate={validityDate}
                            maxDate={limitDate}
                            minDate={firstDate}
                            excludeDates={excludeDates}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        />
                    </div>
                    {(!!crfRequired || !!w8Required) && (
                        <div className="stocks-buy-step1__disclaimer">
                            {!!crfRequired && (
                                <OKMessage type="important">
                                    <FormattedText value="broker-stocksBuyStep1DisclaimerTextForCRF" />
                                </OKMessage>
                            )}
                            {!!w8Required && (
                                <OKMessage type="warning">
                                    <FormattedText value="broker-stocksBuyStep1DisclaimerTextForW8" />
                                </OKMessage>
                            )}
                        </div>
                    )}
                </div>
                <BrokerHolidayErrorModal
                    holidayErrorState={formState.get('holidayError')}
                    onSetHolidayError={this.handleHolidayModalErrorOpen}
                >
                </BrokerHolidayErrorModal>
            </div>
        );
    }
}

BrokerStocksBuyStep1.propTypes = {
    step1: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    resetStep1TitlesInput: PropTypes.func.isRequired,
    resetStep1ApproxImportInput: PropTypes.func.isRequired,
    resetStep1LimitedInput: PropTypes.func.isRequired,
    updateStep1Form: PropTypes.func.isRequired,
    errors: PropTypes.object,
    productValueObject: PropTypes.object,
    immStocksContracts: PropTypes.object,
    immStocksBuy: PropTypes.object,
    productIso: PropTypes.string,
    productCurrency: PropTypes.string,
    productPrice: PropTypes.number.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    setHolidayError: PropTypes.func.isRequired,
    resetLotValuesByLot: PropTypes.func,
    productFile: PropTypes.object
};

module.exports = BrokerStocksBuyStep1;
